import { getServerSideProductProps, ProductDetailServerSideProps } from '../../src/shared/utils/server-side-props';
import useProductDetailPage from '../../src/product/detail/hooks/useProductDetailPage';

import PageMetaData from '../../src/shared/components/PageMeta/PageMetaData';

import MainSiteProvider from '../../src/main/components/shared/MainSiteProvider';
import ProductDetailContainer from '../../src/product/detail/pc/containers/ProductDetailContainer';
import { useScreenName } from '../../src/shared/hooks';
import { ScreenName } from '../../src/shared/amplitude';
import Header from '../../src/header/components/Header';
import { DEFAULT_KEYWORDS } from '../../src/shared/constant/page-meta';

export default function ProductPage({
  product,
  adultVerificationFailed,
  verificationEmployeeFailed,
  error,
}: ProductDetailServerSideProps) {
  useScreenName(ScreenName.PRODUCT_DETAIL_DESCRIPTION);
  useProductDetailPage({
    product,
    adultVerificationFailed,
    verificationEmployeeFailed,
    error,
  });

  if (!product || adultVerificationFailed) {
    return null;
  }

  const { no, name, shortDescription, shareImageUrl } = product;

  return (
    <>
      <PageMetaData
        title={name}
        description={shortDescription}
        image={shareImageUrl}
        url={`/goods/${no}`}
        keyword={DEFAULT_KEYWORDS}
      />
      <div id="top">
        <MainSiteProvider>
          <Header />
        </MainSiteProvider>
        <ProductDetailContainer product={product} />
      </div>
    </>
  );
}

export const getServerSideProps = getServerSideProductProps();
